import { useContext } from "react";
import { TrackContext } from "../contexts/track.context.tsx";

export const useTrack = () => {
  return useContext(TrackContext);
};